const asyncRouter = [
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/dictionary",
    meta: {
      title: "数据字典管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "dictionary",
        component: "views/dataDict/index.vue",
        name: "dictList",
        meta: {
          title: "数据字典管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: "views/dataDict/add/index.vue",
            name: "add-dictionary",
            hidden: true,
            meta: {
              title: "新字典",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: "views/dataDict/detail/index.vue",
            name: "detail-dictionary",
            hidden: true,
            meta: {
              title: "详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/reference",
    meta: {
      title: "高级参照管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "reference",
        component: "views/advanceReferTo/index.vue",
        name: "referToList",
        meta: {
          title: "高级参照管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: "views/advanceReferTo/add/index.vue",
            name: "add-reference",
            hidden: true,
            meta: {
              title: "新参数",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: "views/advanceReferTo/detail/index.vue",
            name: "detail-reference",
            hidden: true,
            meta: {
              title: "参数详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/module-function",
    meta: {
      title: "模块功能管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "module-function",
        component: "views/module_func_manage/index.vue",
        name: "module_func_manage",
        meta: {
          title: "模块功能管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "product-detail",
            component: "views/module_func_manage/product_detail/index.vue",
            name: "product_detail",
            hidden: true,
            meta: {
              title: "产品",
              icon: "mdi-translate",
            },
          },
          {
            path: "function-detail",
            component: "views/module_func_manage/func_detail/index.vue",
            name: "func_detail",
            hidden: true,
            meta: {
              title: "功能详情",
              icon: "mdi-translate",
            },
          },
          {
            path: "function-add",
            component: "views/module_func_manage/add_func/index.vue",
            name: "add_func",
            hidden: true,
            meta: {
              title: "新功能",
              icon: "mdi-translate",
            },
          },
          {
            path: "module-add",
            component: "views/module_func_manage/module_detail/add.vue",
            name: "module_add",
            hidden: true,
            meta: {
              title: "新模块",
              icon: "mdi-translate",
            },
          },
          {
            path: "module-detail",
            component: "views/module_func_manage/module_detail/detail.vue",
            name: "module_detail",
            hidden: true,
            meta: {
              title: "模块详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 菜单管理
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/menu",
    meta: {
      title: "菜单管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "menu",
        component: "views/menu_manage/index.vue",
        name: "menu_manage",
        meta: {
          title: "菜单管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: "views/menu_manage/add/index.vue",
            name: "menu_add",
            hidden: true,
            meta: {
              title: "菜单新增",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: "views/menu_manage/detail/index.vue",
            name: "menu_detail",
            hidden: true,
            meta: {
              title: "菜单详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 客户管理
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/client",
    meta: {
      title: "客户管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "client",
        component: "views/clientmanage/index.vue",
        name: "clientmanage",
        // redirect: 'clientmanage/clientdetail',
        meta: {
          title: "客户管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: "views/clientmanage/clientdetail/index.vue",
            name: "clientdetail",
            hidden: true,
            meta: {
              title: "客户详情",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: "views/clientmanage/addnewuser.vue",
            name: "addnewuser",
            hidden: true,
            meta: {
              title: "新用户",
              icon: "mdi-translate",
            },
          },
          {
            path: "copy",
            component: "views/clientmanage/addcopyuser.vue",
            name: "addcopyuser",
            hidden: true,
            meta: {
              title: "从现有用户添加",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 国际化
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/label-internationalization",
    meta: {
      title: "Label国际化基础数据",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "label-internationalization",
        name: "internationIndex",
        component: "views/internationalization/index.vue",
        meta: {
          title: "Label国际化基础数据",
          icon: "",
        },
        children: [
          {
            path: "translate",
            component:
              "views/internationalization/labelInttranslation/detaillabelInttranslation.vue",
            name: "detaillabelInttranslation",
            hidden: true,
            meta: {
              title: "翻译详情",
              icon: "mdi-translate",
            },
          },
          {
            path: "list",
            component: "views/internationalization/allClientMsg/index.vue",
            name: "allClientMsg",
            hidden: true,
            meta: {
              title: "国际化基础数据列表",
              icon: "mdi-translate",
            },
            children: [
              {
                path: "detail",
                component:
                  "views/internationalization/allClientMsg/detailAllClientMsg.vue",
                name: "detailAllClientMsg",
                hidden: true,
                meta: {
                  title: "详情",
                  icon: "mdi-translate",
                },
              },
              {
                path: "add",
                component:
                  "views/internationalization/allClientMsg/addAllClientMsg.vue",
                name: "addAllClientMsg",
                hidden: true,
                meta: {
                  title: "新增",
                  icon: "mdi-translate",
                },
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/value-internationalization",
    meta: {
      title: "value国际化配置",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "value-internationalization",
        component: "views/internationalization/valueIntconfig/index.vue",
        name: "valueIntconfig",
        // redirect: 'internationalization/clientdetail',
        meta: {
          title: "value国际化配置",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detailvalueIntconfig",
            component:
              "views/internationalization/valueIntconfig/detailvalueIntconfig.vue",
            name: "detailvalueIntconfig",
            hidden: true,
            meta: {
              title: "详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 企业设置

  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/organization",
    meta: {
      title: "企业设置",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "organization",
        component: "views/enterprise/index.vue",
        name: "enterprise",
        meta: {
          title: "企业设置",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: "views/enterprise/enterpriseInfo/index.vue",
            name: "enterpriseInfo",
            hidden: true,
            meta: {
              title: "企业设置详情",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: "views/enterprise/addCompany/index.vue",
            name: "addCompany",
            hidden: true,
            meta: {
              title: "新单位",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 角色管理

  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/role",
    meta: {
      title: "角色管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "role",
        component: "views/role/index.vue",
        name: "role",
        meta: {
          title: "角色管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: "views/role/roleInfo/index.vue",
            name: "roleInfo",
            hidden: true,
            meta: {
              title: "角色管理详情",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: "views/role/addRole/index.vue",
            name: "addRole",
            hidden: true,
            meta: {
              title: "新角色",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/serial-number",
    meta: {
      title: "流水号管理",
      icon: "mdi-translate",
    },
    children: [
      {
        //流水号管理
        path: "serial-number",
        component: "views/serial-number/index.vue",
        name: "serial-number",
        meta: {
          title: "流水号管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "serial-number/detail",
        component: "views/serial-number/detailSerialNumber.vue",
        name: "detailSerialNumber",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "serial-number/add",
        component: "views/serial-number/addSerialNumber.vue",
        name: "addSerialNumber",
        hidden: true,
        meta: {
          title: "新流水号",
          icon: "mdi-translate",
        },
      },
    ],
  },
  //员工管理
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/staff",
    meta: {
      title: "员工管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "staff",
        component: "views/staffmanagement/staffs_msg/index.vue",
        name: "staffmanagement",
        // redirect: 'clientmanage/clientdetail',
        meta: {
          title: "员工信息",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component:
              "views/staffmanagement/staffs_msg/detailstaffmanagement.vue",
            name: "detailstaffmanagement",
            hidden: true,
            meta: {
              title: "员工信息详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        path: "staff-add",
        component: "views/staffmanagement/addstaff/addstaff.vue",
        name: "addstaff",
        meta: {
          title: "新增员工",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-property-group",
        component:
          "views/staffmanagement/staffPropertyGroup/staffPropertyGroup.vue",
        name: "staffPropertyGroup",
        meta: {
          title: "staffPropertyGroup",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component:
              "views/staffmanagement/staffPropertyGroup/detailstaffPropertyGroup.vue",
            name: "detailstaffPropertyGroup",
            hidden: true,
            meta: {
              title: "detailstaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component:
              "views/staffmanagement/staffPropertyGroup/addstaffPropertyGroup.vue",
            name: "addstaffPropertyGroup",
            hidden: true,
            meta: {
              title: "addstaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        //员工变更管理
        path: "staff-movement",
        component: "views/staffmanagement/staffVariation/index.vue",
        name: "staffVariation",
        meta: {
          title: "员工变更管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-movement/detail",
        component:
          "views/staffmanagement/staffVariation/detailStaffVariation.vue",
        name: "detailStaffVariation",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-movement/add",
        component: "views/staffmanagement/staffVariation/addStaffVariation.vue",
        name: "addStaffVariation",
        hidden: true,
        meta: {
          title: "新员工变动",
          icon: "mdi-translate",
        },
      },
      {
        //员工离职管理
        path: "staff-termination",
        component: "views/staffmanagement/staffLeave/index.vue",
        name: "staffLeave",
        meta: {
          title: "员工离职管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-termination/detail",
        component: "views/staffmanagement/staffLeave/detailStaffLeave.vue",
        name: "detailStaffLeave",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-termination/add",
        component: "views/staffmanagement/staffLeave/addStaffLeave.vue",
        name: "addStaffLeave",
        hidden: true,
        meta: {
          title: "新人员离职",
          icon: "mdi-translate",
        },
      },
      // 员工离职交接
      {
        path: "staff-handover",
        component: "views/staffmanagement/staffConnect/index.vue",
        name: "staffConnect",
        meta: {
          title: "员工离职交接",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-handover/detail",
        component: "views/staffmanagement/staffConnect/detailStaffConnect.vue",
        name: "detailStaffConnect",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-handover/add",
        component: "views/staffmanagement/staffConnect/addStaffConnect.vue",
        name: "addStaffConnect",
        hidden: true,
        meta: {
          title: "新离职交接",
          icon: "mdi-translate",
        },
      },
      {
        //员工转正
        path: "staff-promotion",
        component: "views/staffmanagement/staffOfficial/index.vue",
        name: "staffOfficial",
        meta: {
          title: "员工转正管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-promotion/detail",
        component:
          "views/staffmanagement/staffOfficial/detailStaffOfficial.vue",
        name: "detailStaffOfficial",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-promotion/add",
        component: "views/staffmanagement/staffOfficial/addStaffOfficial.vue",
        name: "addStaffOfficial",
        hidden: true,
        meta: {
          title: "新员工转正",
          icon: "mdi-translate",
        },
      },
      {
        //员工群组管理
        path: "staff-group",
        component: "views/staffmanagement/staffGroup/index.vue",
        name: "staffGroup",
        meta: {
          title: "员工群组管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-group/detail",
        component: "views/staffmanagement/staffGroup/detailStaffGroup.vue",
        name: "detailStaffGroup",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "staff-group/add",
        component: "views/staffmanagement/staffGroup/addStaffGroup.vue",
        name: "addStaffGroup",
        hidden: true,
        meta: {
          title: "新增员工群组",
          icon: "mdi-translate",
        },
      },
    ],
  },
  //组织架构
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/organization-structure",
    alwaysShow: true,
    name: "o_f_manage",
    meta: {
      title: "组织框架管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "organization-structure",
        component: "views/o_f_manage/department_manage/index.vue",
        name: "department_manage",
        meta: {
          title: "部门管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "level",
            component:
              "views/o_f_manage/department_manage/department_list/index.vue",
            name: "department_list",
            meta: {
              title: "部门列表",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "level/detail",
            component: "views/o_f_manage/department_manage/detail/index.vue",
            name: "department_detail",
            meta: {
              title: "部门详情",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "level/add",
            component: "views/o_f_manage/department_manage/add/index.vue",
            name: "department_add",
            meta: {
              title: "部门新增",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      {
        path: "job-position",
        component: "views/o_f_manage/jobs_manage/index.vue",
        name: "jobs_manage",
        meta: {
          title: "岗位管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component:
              "views/o_f_manage/jobs_manage/newpositions/newpositions.vue",
            name: "new_positions",
            meta: {
              title: "新岗位",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "detail",
            component:
              "views/o_f_manage/jobs_manage/newpositions/detailpositions.vue",
            name: "detail_positions",
            meta: {
              title: "详情页",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      {
        path: "job-position-level",
        component: "views/o_f_manage/Post_level_management/index.vue",
        name: "Post_level_management",
        meta: {
          title: "岗位等级管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: "views/o_f_manage/Post_level_management/detailPost.vue",
            name: "detailPost",
            meta: {
              title: "详情",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add",
            component: "views/o_f_manage/Post_level_management/addOne.vue",
            name: "addOne",
            meta: {
              title: "新增单个层级",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add-group",
            component: "views/o_f_manage/Post_level_management/addGroup.vue",
            name: "addGroup",
            meta: {
              title: "新增一组",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      {
        path: "Organizational-change-management",
        component: "views/o_f_manage/organizationalManagement/index.vue",
        name: "organizationalManagement",
        meta: {
          title: "组织架构变动管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component:
              "views/o_f_manage/organizationalManagement/detailOrganizationalManagement.vue",
            name: "detailOrganizationalManagement",
            meta: {
              title: "详情",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add",
            component:
              "views/o_f_manage/organizationalManagement/addOrganizationalManagement.vue",
            name: "addOrganizationalManagement",
            meta: {
              title: "新增单个层级",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/password-intensity",
    meta: {
      title: "员工密码强度",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "password-intensity",
        component: "views/passwordIntensity/index.vue",
        name: "passwordIntensity",
        meta: {
          title: "员工密码强度",
          icon: "mdi-translate",
        },
      },
      {
        path: "password-intensity/edit",
        component: "views/passwordIntensity/passwordIntensity.vue",
        name: "detailPasswordIntensity",
        hidden: true,
        meta: {
          title: "密码设置",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/approve-on-behalf",
    meta: {
      title: "审批代理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "approve-on-behalf",
        component: "views/approver/index.vue",
        name: "approver",
        meta: {
          title: "审批代理",
          icon: "mdi-translate",
        },
      },
      {
        path: "approve-on-behalf/edit",
        component: "views/approver/detailApprover.vue",
        name: "detailApprover",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "approve-on-behalf/add",
        component: "views/approver/addApprover.vue",
        name: "addApprover",
        hidden: true,
        meta: {
          title: "新审批代理",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/apply-on-behalf",
    meta: {
      title: "业务申请代理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "apply-on-behalf",
        component: "views/businessApply/index.vue",
        name: "businessApply",
        meta: {
          title: "业务申请代理",
          icon: "mdi-translate",
        },
      },
      {
        path: "apply-on-behalf/edit",
        component: "views/businessApply/detailBusinessApply.vue",
        name: "detailBusinessApply",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "apply-on-behalf/add",
        component: "views/businessApply/addBusinessApply.vue",
        name: "addBusinessApply",
        hidden: true,
        meta: {
          title: "新业务代理",
          icon: "mdi-translate",
        },
      },
    ],
  },
  // 邮件模板
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/email-template",
    meta: {
      title: "邮件模板",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "email-template",
        component: "views/emailtemplate/index.vue",
        name: "emailtemplate",
        meta: {
          title: "邮件模板",
          icon: "mdi-translate",
        },
      },
      {
        path: "email-template/detail",
        component: "views/emailtemplate/detailemailtemplate.vue",
        name: "detailemailtemplate",
        hidden: true,
        meta: {
          title: "模板详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "email-template/add",
        component: "views/emailtemplate/addemailtemplate.vue",
        name: "addemailtemplate",
        hidden: true,
        meta: {
          title: "新增模板",
          icon: "mdi-translate",
        },
      },
    ],
  },
  //系统参数
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/system-parameter",
    meta: {
      title: "系统参数",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "system-parameter",
        component: "views/systemParameter/index.vue",
        name: "systemParameter",
        meta: {
          title: "系统参数",
          icon: "mdi-translate",
        },
      },
      {
        path: "system-parameter/detail",
        component: "views/systemParameter/detailSystemParameter.vue",
        name: "detailSystemParameter",
        hidden: true,
        meta: {
          title: "参数详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "system-parameter/add",
        component: "views/systemParameter/addSystemParameter.vue",
        name: "addSystemParameter",
        hidden: true,
        meta: {
          title: "新参数",
          icon: "mdi-translate",
        },
      },
    ],
  },
  // 定时任务
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/scheduled-task",
    meta: {
      title: "定时任务",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "scheduled-task",
        component: "views/timedTask/index.vue",
        name: "timedTask",
        meta: {
          title: "定时任务",
          icon: "mdi-translate",
        },
      },
      {
        path: "scheduled-task/detail",
        component: "views/timedTask/detailTimedTask.vue",
        name: "detailTimedTask",
        hidden: true,
        meta: {
          title: "任务详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "scheduled-task/add",
        component: "views/timedTask/addTimedTask.vue",
        name: "addTimedTask",
        hidden: true,
        meta: {
          title: "新增定时任务",
          icon: "mdi-translate",
        },
      },
    ],
  },
  // 密码安全设置
  // {
  //   path: "/",
  //   component: "LAYOUT/index.vue",
  //   redirect: '/super-admin-password-strength',
  //   meta: {
  //     title: "密码安全设置",
  //     icon: "mdi-translate"
  //   },
  //   children: [
  //     {
  //       path: "super-admin-password-strength",
  //       component: "views/passwordSet/index.vue",
  //       name: "passwordSet",
  //       meta: {
  //         title: "密码安全设置",
  //         icon: "mdi-translate"
  //       }
  //     }
  //   ]
  // },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/push-notification-template",
    meta: {
      title: "推送消息模板",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "push-notification-template",
        component: "views/pushTemplate/index.vue",
        name: "pushtemplate",
        meta: {
          title: "推送消息模板",
          icon: "mdi-translate",
        },
        // children: [
        //   {
        //     path: "detail",
        //     component: "views/pushTemplate/detailPushTemplate.vue",
        //     name: "detailpushtemplate",
        //     hidden: true,
        //     meta: {
        //       title: "模板详情",
        //       icon: "mdi-translate"
        //     },
        //   },
        //   {
        //     path: "add",
        //     component: "views/pushTemplate/addPushTemplate.vue",
        //     name: "addpushtemplate",
        //     hidden: true,
        //     meta: {
        //       title: "新增模板",
        //       icon: "mdi-translate"
        //     },
        //   }
        // ]
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/code-logic",
    meta: {
      title: "代码逻辑配置管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "code-logic",
        component: "views/codeLogicManagement/index.vue",
        name: "codeLogic",
        meta: {
          title: "代码逻辑配置管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "code-logic/detail",
        component: "views/codeLogicManagement/detailCodeLogic.vue",
        name: "detailCodeLogic",
        hidden: true,
        meta: {
          title: "详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "code-logic/add",
        component: "views/codeLogicManagement/addCodeLogic.vue",
        name: "addCodeLogic",
        hidden: true,
        meta: {
          title: "新代码逻辑配置",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/system-superdmin",
    meta: {
      title: "mrc系统管理员",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "system-superdmin",
        component: "views/mrc_system_admin/index.vue",
        name: "mrc_system_admin",
        meta: {
          title: "mrc系统管理员",
          icon: "mdi-translate",
        },
      },
      {
        path: "system-superdmin/detail",
        name: "mrc_system_detail",
        component: "views/mrc_system_admin/detail/index.vue",
        hidden: true,
        meta: {
          title: "mrc系统管理员详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "system-superdmin/add",
        name: "mrc_system_add",
        component: "views/mrc_system_admin/add/index.vue",
        hidden: true,
        meta: {
          title: "mrc系统管理员新增",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/client-admin",
    meta: {
      title: "管理员账号管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "client-admin",
        component: "views/admin_account_manage/index.vue",
        name: "admin_account_manage",
        meta: {
          title: "管理员账号管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "client-admin/detail",
        name: "admin_account_detail",
        component: "views/admin_account_manage/detail/index.vue",
        hidden: true,
        meta: {
          title: "管理员账号管理详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "client-admin/add",
        name: "admin_account_add",
        component: "views/admin_account_manage/add/index.vue",
        hidden: true,
        meta: {
          title: "管理员账号管理新增",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/data-stored-procedure",
    meta: {
      title: "存储过程管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "data-stored-procedure",
        component: "views/data-stored-procedure/index.vue",
        name: "data-stored-procedure",
        meta: {
          title: "存储过程管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "data-stored-procedure/detail",
        name: "data-stored-procedure-detail",
        component: "views/data-stored-procedure/detail/index.vue",
        hidden: true,
        meta: {
          title: "存储过程详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "data-stored-procedure/add",
        name: "data-stored-procedure-add",
        component: "views/data-stored-procedure/add/index.vue",
        hidden: true,
        meta: {
          title: "存储过程管理新增",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/data-view",
    meta: {
      title: "视图管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "data-view",
        component: "views/data-view/index.vue",
        name: "data-view",
        meta: {
          title: "视图管理",
          icon: "mdi-translate",
        },
      },
      {
        path: "data-view/detail",
        name: "data-view-detail",
        component: "views/data-view/detail/index.vue",
        hidden: true,
        meta: {
          title: "视图详情",
          icon: "mdi-translate",
        },
      },
      {
        path: "data-view/add",
        name: "data-view-add",
        component: "views/data-view/add/index.vue",
        hidden: true,
        meta: {
          title: "视图管理新增",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/my-account",
    meta: {
      title: "我的账户",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "my-account",
        component: "views/userAccount/index.vue",
        name: "userAccount",
        meta: {
          title: "我的账户",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: "LAYOUT/index.vue",
    redirect: "/my-info",
    meta: {
      title: "个人资料",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "my-info",
        name: "userInfo",
        component: "views/userInfo/index.vue",
        meta: {
          title: "个人资料",
          icon: "mdi-translate",
        },
      },
    ],
  },
];
export default asyncRouter;
